import React from 'react';
import ReactDOM from 'react-dom';


export type ComponentCallback = ({unmountComponent }: {unmountComponent: () => void}) => React.ReactElement

const renderInExceptionRoot = (componentCallback:ComponentCallback ) => {
  const modalRoot = document.getElementById('exception-root') as HTMLElement;
  const lastNode = getLastNode(modalRoot);
  const unmountComponent = () => {
    ReactDOM.unmountComponentAtNode(lastNode);
  };
  ReactDOM.render(
    <div>
      {componentCallback({unmountComponent})}
    </div>,
    lastNode,
  );
  return unmountComponent;
};

export default renderInExceptionRoot;

const getLastNode = (rootNode: HTMLElement): HTMLElement => {
  if (rootNode.hasChildNodes()) {
    const lastChildOfRootNode = rootNode.lastChild as HTMLElement;
    return getLastNode(lastChildOfRootNode);
  } else {
    return rootNode;
  }
};

